// test908
(908 && 0);
